<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CYdHdp/image/cover.jpg?1731429793677" alt="This image is the cover for the book Spiritual Power of Empathy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Spiritual Power of Empathy
      </h1>
      <p class="bookDescription body article font2">
        <p>Discover your innate empathic abilities with popular author Cyndi Dale as your guide. With this hands-on training course, you'll learn how to comfortably use empathy for better relationships and healing the self and others.</p><p><i>The Spiritual Power of Empathy</i> presents this often-unrecognized ability in accessible ways, allowing you to discover an expanded awareness of what empathy is, how it works, and the myriad ways it manifests. Develop deeper connections with your loved ones, use specialized techniques for screening and filtering information, and gain insights on how to overcome the difficulties empaths often face. With the power of empathy, you'll transform the way you live and connect with the world around you.</p><p><b>2015 IPPY Award Gold Medal Winner in New Age (Mind-Body-Spirit)</b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cyndi Dale
      </h2>
      
      <p class="authorDescription body article"><P><B>Cyndi Dale</B> is an internationally renowned author, speaker, and healer. She has written more than thirty books, including <I>Energy Work for the Everyday to Elite Athlete</I>. Her year-long apprenticeship program through her company, Essential Energy, assists individuals in developing their natural intuitive and healing gifts. She also teaches in-depth classes via the Shift Network. Visit her at CyndiDale.com.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Llewellyn Publications is an imprint of Llewellyn Worldwide Ltd. 
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?75aa7c0b